<div class="content-header">Changes Requested</div>
<div class="header-helper">
  These are the changes to the root zone database record, and will be implemented following successful processing of the request.
</div>

<div class="content content-with-elevation">
  <summary-of-changes [newDelegation]="false" [changeRequest]="changeRequestVO"
                      [showTicketNumbers]="false"></summary-of-changes>
</div>

